import { normalizeMediaUrl } from "@/lib/media";
import { supabase } from "@/lib/supabase";

export interface PublicPostPreview {
  caption: string;
  mediaUrl: string;
  authorName: string;
  authorUsername: string;
}

export interface PublicProfilePreview {
  fullName: string;
  username: string;
  avatarUrl: string;
}

export async function fetchPublicProfilePreview(
  userId: string,
): Promise<PublicProfilePreview | null> {
  const { data: profile, error } = await supabase
    .from("profiles")
    .select("id,username,full_name,avatar_url,is_private")
    .eq("id", userId)
    .limit(1)
    .maybeSingle();

  if (error || !profile || profile.is_private === true) return null;

  return {
    fullName: String(profile.full_name || profile.username || "Daywia user"),
    username: String(profile.username || ""),
    avatarUrl: normalizeMediaUrl(String(profile.avatar_url || "")),
  };
}

export async function fetchPublicPostPreview(
  postId: string,
): Promise<PublicPostPreview | null> {
  const { data: post, error } = await supabase
    .from("posts")
    .select("id,user_id,content,caption,audience,media_urls,thumbnail_url")
    .eq("id", postId)
    .limit(1)
    .maybeSingle();

  if (error || !post || post.audience !== "public") return null;

  const { data: profile } = await supabase
    .from("profiles")
    .select("username,full_name,is_private")
    .eq("id", post.user_id)
    .limit(1)
    .maybeSingle();

  if (!profile || profile.is_private === true) return null;
  const media = Array.isArray(post.media_urls)
    ? post.media_urls.find((value): value is string => typeof value === "string")
    : null;

  return {
    caption: String(post.content || post.caption || ""),
    mediaUrl: normalizeMediaUrl(media || post.thumbnail_url || ""),
    authorName: String(profile.full_name || profile.username || "Daywia user"),
    authorUsername: String(profile.username || ""),
  };
}
